// === CENTRAL ICON REGISTRY ===
// Maps a short, stable string key to its phosphor icon component. This is the "surface"
// that products/registry.ts refers to: it stores an `iconKey` string and stays icon-free,
// expecting each rendering surface to resolve the key here.
//
// Add a key here once; every consumer references it by name via <SectionIcon name="..." />
// and never imports phosphor directly. New section-header icons get registered as the
// remaining screens are migrated onto SectionIcon.

import { Shield, ShieldCheck, Users, House, Car, User, ClipboardText } from 'phosphor-react';

export type SectionIconName =
  | 'shield'
  | 'shield-check'
  | 'persons'
  | 'house'
  | 'car'
  | 'user'
  | 'clipboard';

// All phosphor icons share one component type, so `typeof Shield` types the whole map.
export const sectionIcons: Record<SectionIconName, typeof Shield> = {
  'shield': Shield,
  'shield-check': ShieldCheck,
  'persons': Users,
  'house': House,
  'car': Car,
  'user': User,
  'clipboard': ClipboardText,
};
